<ng-container>
  <div class="wrapper">
    <mat-card class="sideBarAccordion" sticky:true>
      <div class="pannelHeader">
        <p></p>
      </div>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title></mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li><span>
                <mat-icon color="primary"></mat-icon>&nbsp;
              </span></li>
            <li><span>
                <mat-icon color="primary"></mat-icon>&nbsp;
              </span><span></span></li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="paymentCont">
        <ul>
          <li  class="taxes"><span></span><span></span></li>
          <li  class="discount"><span></span><span> </span></li>
        </ul>
        <p class="grandTotle"><span></span></p>
        <!-- <button mat-button (click)="nextStep()">Continue</button> -->
      </div>
      <div class="information">
        <h4></h4>
        <p><a href="tel:+911142521000"></a> </p>
        <h5></h5>
        <ul>
          <li>
            <img  alt="" class="img-fluid">
            <div class="content">
              <h5></h5>
              <p></p>
            </div>
          </li>
          <li>
            <img  alt="" class="img-fluid">
            <div class="content">
              <h5></h5>
              <p></p>
            </div>
          </li>
          <li>
            <img alt="" class="img-fluid">
            <div class="content">
              <h5> </h5>
              <p></p>
            </div>
          </li>
        </ul>
      </div>
    </mat-card>
  </div>
  
</ng-container>
